import React from "react";
import PropTypes from "prop-types";

import { useBooleanState } from "hooks";
import { WithRenderTracking } from "components/DatadogTracker";
import { useFeatures } from "components/FeatureFlag";

import { UpgradeModal } from "scenes/Hubly/components/Workspace/components/UpgradeModal";

import { useNextWorkflowConditionsEligibility } from "../../hooks";
import { Conditions } from "..";

const UpgradeModalWithTracking = WithRenderTracking(
  UpgradeModal,
  "ConditionalNextWorkflowsUpgradeModal"
);

function NextWorkflowConditionsLauncher({ ...conditionsProps }) {
  const { resourceLink } = useFeatures("conditional-next-workflows");
  const { checkEligibility, eligibilityMessage } =
    useNextWorkflowConditionsEligibility();
  const [isOpen, openUpgradeModal, closeUpgradeModal] = useBooleanState();

  return (
    <React.Fragment>
      <Conditions
        itemType="nextWorkflow"
        checkEligibility={async () => {
          const res = await checkEligibility();
          if (res) return true;
          openUpgradeModal();

          return false;
        }}
        {...conditionsProps}
      />
      {isOpen && (
        <UpgradeModalWithTracking
          title={eligibilityMessage.title}
          upgradeSubject="Upgrade My Plan - Enable Conditional Next Workflows"
          description="I am interested in the Conditional Next Workflows feature."
          onClose={closeUpgradeModal}
          message={
            <React.Fragment>
              <div style={{ paddingBottom: "20px" }}>
                {eligibilityMessage.content}
              </div>
              <div data-test="learn-more">
                Want to learn more about conditional next workflows? Find videos
                and resources{" "}
                <a
                  href={resourceLink || "https://help.myhubly.com"}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-dd-action-name="learn-more-conditional-next-workflows"
                >
                  here
                </a>
                .
              </div>
            </React.Fragment>
          }
          data-dd-action-name="change-plan-from-conditional-next-workflows"
        />
      )}
    </React.Fragment>
  );
}

NextWorkflowConditionsLauncher.propTypes = {
  disabled: PropTypes.bool,
  eligibilityMessage: PropTypes.string,
  resourceLink: PropTypes.string,
};
NextWorkflowConditionsLauncher.defaultProps = {
  disabled: false,
  eligibilityMessage: undefined,
  resourceLink: "https://help.myhubly.com",
};

export default NextWorkflowConditionsLauncher;
